import { SxGeneral } from "../../utils/types/generals"

type SxStyles = SxGeneral<'files' | 'add' | 'error' | 'titleModal' | 'container' | 'flex' | 'containerTitle' | 'see' | 'containerSee' | 'amountContainer' | 'amount' | 'containerUl' | 'containerErrors'>

export const useStyles = (): SxStyles => {
  return {
    files: {
      display: 'none',
    },
    add: {
      color: 'blue.main',
    },
    error: {
      '&.MuiPaper-root.MuiAccordion-root': {
        borderColor: 'c_red.main',
        borderWidth: '1px',
        borderStyle: 'solid'
      },
      '& .MuiTypography-root':{
        color: 'c_red.main'
      },
      '& .MuiIconButton-root':{
        color: 'c_red.main'
      },
    },
    flex: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    containerTitle: {
      width: 'calc(100% - 120px)',
      wordBreak: 'break-word',
      '& span': {
        color: 'c_red.400',
      },
    },
    see: {
      color: 'secondary.main',
    },
    containerSee: {
      display: 'flex',
      alignItems: 'center',
      width: '120px',
      justifyContent: 'end',
      gap: '5px',
    },
    amountContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
    },
    amount: {
      fontSize: '11px',
    },
    containerUl: {
      '& li': {
        fontSize: '12px',
      },
    },
    containerErrors: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      gap: '20px',
      justifyContent: 'center',
    },
    titleModal: {
      textAlign: 'center',
      fontSize: '16px',
      color: 'c_grey.300',
      fontWeight: '800',
    },
    container: {
      marginTop: 2
    }
  }
}